import { gql } from '@apollo/client'
import { VisuallyHidden } from '@farol-ds/react'
import * as RDialog from '@radix-ui/react-dialog'
import { ReactNode } from 'react'

import { useSendViewItemEvent } from '../../hooks/use-send-view-item-event'
import { useModalContext } from '../context'
import { FullscreenModal } from '../fullscreen-modal'
import { FullscreenModalLock_OfferLockBodyFragment } from './__generated__/fullscreen-modal-lock.graphql'
import styles from './fullscreen-modal-lock.module.scss'

export interface FullscreenModalLockProps {
  children: ReactNode
  offerLockBody: FullscreenModalLock_OfferLockBodyFragment
  footerContent?: ReactNode
  addHeader?: boolean
}

export function FullscreenModalLock({
  children,
  footerContent,
  offerLockBody,
  addHeader = true,
}: FullscreenModalLockProps) {
  const { open, setOpen } = useModalContext()
  const { sendViewItemRef } = useSendViewItemEvent({ offerLockBody })

  return (
    <FullscreenModal open={open} onOpenChange={setOpen}>
      <FullscreenModal.Content data-testid="fullscreen-modal-lock-content">
        {addHeader && (
          <>
            <FullscreenModal.Header
              data-testid="fullscreen-modal-lock-header"
              className={styles.fullscreenModalLockHeader}
            >
              <VisuallyHidden>Jusbrasil</VisuallyHidden>
              <FullscreenModal.IconClose data-testid="fullscreen-modal-lock-icon-close" />
            </FullscreenModal.Header>
          </>
        )}
        <VisuallyHidden>
          <RDialog.Title>Assine o Jusbrasil</RDialog.Title>
        </VisuallyHidden>
        <FullscreenModal.Body data-testid="fullscreen-modal-lock-body" ref={sendViewItemRef}>
          {children}
        </FullscreenModal.Body>
        {footerContent && (
          <FullscreenModal.Footer data-testid="fullscreen-modal-lock-footer">
            {footerContent}
          </FullscreenModal.Footer>
        )}
      </FullscreenModal.Content>
    </FullscreenModal>
  )
}

FullscreenModalLock.fragments = {
  offerLockBody: gql`
    fragment FullscreenModalLock_offerLockBody on OfferLockBody {
      ...UseSendViewItemEvent_offerLockBody
    }

    ${useSendViewItemEvent.fragments.offerLockBody}
  `,
}
